<template>
  <div
    class="auth-page min-h-screen relative w-full bg-center-top bg-no-repeat bg-cover text-center pb-4 sm:pb-20"
  >
    <div class="py-5">
      <img alt="startup ACT" class="startup-auth-logo" src="../../assets/img/logo-CQE.png" />
    </div>

    <div
      class="wrap-login w-68 sm:w-75 max-w-full bg-white shadow-lg rounded-sm p-5 mx-auto"
    >
      <h2
        class="text-2xl font-bold leading-normal text-red uppercase border-b-2 border-red-lighter p-5 mb-4"
      >
        {{ $t('auth.register') }}
      </h2>
      <p class="text-blue p-qu" v-if="code_invit == null">{{ $t('auth.you_are') }}</p>
      <div class="container hidden" v-if="code_invit == null">
        <div :class=" role=='Startup' ? 'radio st-d st-d-selected' : 'radio st-d'">
           <input id="startup" name="radio" v-model="role" value="Startup" type="radio" checked>
           <label for="startup" class="radio-label st-l"></label>
           <span :class=" role=='Startup' ? 'st-s st-selected' : 'st-s'" @click="updateRole('Startup')">{{ $t('auth.startup') }}</span>
        </div>
        <!-- <div :class=" role=='sso' ? 'radio st-d st-d-selected' : 'radio st-d'">
          <input id="sso" name="radio" type="radio" v-model="role" value="sso">
          <label  for="sso" class="radio-label st-l"></label>
          <span :class=" role=='sso' ? 'st-s st-selected' : 'st-s'" @click="updateRole('sso')">{{ $t('auth.support_mechanism') }}</span>
        </div>
        <div :class=" role=='Investor' ? 'radio st-d st-d-selected' : 'radio st-d'">
           <input id="Investor" name="radio" v-model="role" value="Investor" type="radio" checked>
           <label for="Investor" class="radio-label st-l"></label>
           <span :class=" role=='Investor' ? 'st-s st-selected' : 'st-s'" @click="updateRole('Investor')">{{ $t('auth.investor') }}</span>
        </div> -->
      </div>
      <div
        v-if="errors != null"
        class="bg-red-lighter border border-red-light text-red-dark text-sm px-4 py-3 mb-4 rounded relative"
        role="alert"
      >
        <ul class="error-messages block sm:inline text-left p-0">
          <li v-for="(v, k) in errors" :key="k" class="mx-2">
            {{  isArray(v.message) ? v.message[0] : v.message }}
          </li>
        </ul>
      </div>
      <div
        v-if="msg_error != null"
        class="bg-red-lighter border border-red-light text-red-dark text-sm px-4 py-3 mb-4 rounded relative"
        role="alert"
      >
          <li class="ml-5 mx-5">
            {{ this.msg_error }}
          </li>
      </div>
      <div
        v-if="notice && !msg_error"
        class="border border-green-light text-green text-sm px-4 py-3 mb-4 rounded"
      >
        <div class="relative  block sm:inline text-left p-0">
          {{ $t(notice) }}
        </div>
      </div>
      <div
        v-if="termError"
        class="bg-red-lighter border border-red-light text-red-dark text-sm px-4 py-3 mb-4 rounded relative"
        role="alert"
      >
        <ul class="error-messages block sm:inline text-left p-0 list-reset">
          <li class="mx-2">
            {{ $t('auth.termAccept') }}
          </li>
        </ul>
      </div>
      <form autocomplete="off" v-on:submit.prevent="onSubmit" class="mt-4">
        <div class="form-group">
          <sp-input
          theme="default"
            name="first_name"
            :placeholder="$t('team.firstname')"
            type="text"
            v-model="first_name"
          ></sp-input>
        </div>

        <div class="form-group">
          <sp-input
          theme="default"
            name="last_name"
            :placeholder="$t('team.lastname')"
            type="text"
            v-model="last_name"
          ></sp-input>
        </div>

        <div class="form-group">
          <sp-input
          theme="default"
            name="email"
            :placeholder="$t('team.email')"
            type="text"
            v-model="email"
          ></sp-input>
        </div>

        <div class="form-group">
          <sp-input
            theme="default"
            name="password"
            :placeholder="$t('team.password')"
            type="password"
            v-model="password"
            @input="checkPassword"
          ></sp-input>
          <p v-if="password && anyErrors && errors == null" class="bg-red-lighter border border-red-light text-red-dark text-sm px-4 py-3 mb-4 rounded relative" role="alert">
            Le mot de passe doit contenir au moins
            <span v-for="(error, rule) in passwordErrors" v-if="error">{{ errorMessages[rule] }}</span>
          </p>
        </div>

        <div class="form-group">
          <sp-input
          theme="default"
            name="password_confirmation"
            :placeholder="$t('team.password_confirmation')"
            type="password"
            v-model="password_confirmation"
          ></sp-input>
        </div>
        <!--<div class="form-group">
          <sp-input
            name="registration_code"
            :placeholder="$t('team.registration_code')"
            type="text"
            v-model="registration_code"
          ></sp-input>
        </div>-->
        <!--<div class="mb-5">
          <sp-checkbox
            theme="default2"
            name="option"
            id="agree"
            class="text-sm text-blue-lighter inline-block mr-1"
            :checked="terms"
            @input="onChange"
          >
           {{ $t('auth.agree_signing') }}
          </sp-checkbox>
          <a
            theme="primary"
            class="inline-block text-sm text-blue hover:text-blue-dark"
            target="_blank"
            href="http://www.startupact.tn/terms"
            >{{ $t('auth.terms__conditions') }}</a
          >
          <span class="text-blue inline-block mx-1">{{ $t('auth.and') }}</span>
          <a
            theme="primary"
            class="inline-block text-sm text-blue hover:text-blue-dark"
            target="_blank"
            href="http://www.startupact.tn/privacy"
            >{{ $t('auth.privacy_policy') }}
            </a>
        </div>-->

        <div class="text-center">
          <sp-button theme="primary" space="normal" class="w-full uppercase" :class="disabled_class" type="submit">
            {{ $t('auth.sing_up') }}
          </sp-button>
        </div>
      </form>

      <div
        class="flex items-center justify-center border-t border-blue-lighter pt-5 pb-2"
      >
        <p class="text-blue">{{ $t('auth.have_account') }}</p>
        <sp-link
          theme="warning"
          class="no-underline cursor-pointer transition-all inline-block ml-2 font-bold hover:text-red-light text-red" 
          :to="{ name: 'login', params: { codeInvit: this.$route.params.codeInvit }}"
          >{{ $t("auth.login") }}</sp-link
        >
      </div>
    </div>

   
    <footer
      class="flex items-center justify-between text-grey-darker bg-grey-lighter absolute md:absolute pin-b pin-l invisible md:visible w-full py-1 px-3 transition-all"
    >
      <div class="flex items-center">
        <!-- <img
          class="mh-8 mx-2"
          alt="Ministère des Technologies de la Communication et de la Transformation Digitale"
          src="../../assets/img/drapeau.png"
        />
        <span class=" text-xxs opacity-60"
          >{{ $t('auth.ministry') }}</span
        > -->
      </div>
      <div class="sm:w-70 w-60 text-right text-xs">
        {{ $t('auth.technology_by') }}<a class="inline-block text-sm font-bold no-underline cursor-pointer transition-all text-grey-darker hover:text-grey-darker" href="https://www.satoripop.com/" target="_blank"> satoripop</a>
      </div>
    </footer>
  </div>
</template>

<style scoped>
.radio {
  margin: 0.5rem 0;
}
.radio input[type=radio] {
  position: absolute;
  opacity: 0;
}
.radio input[type=radio] + .radio-label:before {
  content: "";
  background: #ffffff;
  border-radius: 100%;
  border: 1px solid #b4b4b4;
  display: inline-block;
  width: 1.2em;
  height: 1.2em;
  position: relative;
  margin-right: 0.2em;
  vertical-align: top;
  cursor: pointer;
  text-align: center;
  transition: all 250ms ease;
}
.cont-r{
  display: flex;
  max-height: 65px;
  margin-bottom: 10px;
}
.st-d{
  background-color: #eaecf1; 
  padding: 12px 0; 
  min-width: 100px;
  border-radius: 7px;
  margin-bottom: inherit;
}
.st-d-selected{
  border: 1px solid #7d8593
}
.st-l{
  padding: 0px 8px 0 10px;  
  float: left;
}
.st-s{
  display: block; 
  text-align: left;
}
.st-selected{
  color: #ee0049;
}
.ss-d{
  margin-left: 20px; 
  background-color: #eaecf1; 
  padding: 4px 0; 
  border-radius: 7px;
  margin-bottom: inherit;
}
.p-qu{
  margin-bottom: 8px;
}
.ss-l{
  padding: 9px 8px 0 10px; 
  float: left;
}
.radio input[type=radio]:checked + .radio-label:before {
  background-color: #ee0049;
  box-shadow: inset 0 0 0 4px #f4f4f4;
}
.radio input[type=radio]:focus + .radio-label:before {
  outline: none;
  border-color: #ee0049;
}
.radio input[type=radio]:disabled + .radio-label:before {
  box-shadow: inset 0 0 0 4px #f4f4f4;
  border-color: #b4b4b4;
  background: #b4b4b4;
}
.radio input[type=radio] + .radio-label:empty:before {
  margin-right: 0;
}
</style>

<script>
import { mapState } from "vuex";
import { REGISTER,CLEAR_ERROR,GET_EMAIL_CODE_INVIT } from "@/store/actions.type";

import Link from "@/components/spKit/Link.vue";
import Button from "@/components/spKit/Button.vue";
import Input from "@/components/spKit/Input.vue";
import Checkbox from "@/components/spKit/Checkbox.vue";

export default {
  name: "Register",
  components: {
    "sp-link": Link,
    "sp-button": Button,
    "sp-input": Input,
    "sp-checkbox": Checkbox
  },
  data() {
    return {
      first_name: "",
      last_name: "",
      email: "",
      password: "",
      password_confirmation: "",
      registration_code: "code954c0cvx0s0A0c0test012Aq5PK1d",
      code_invit: this.$route.params.codeInvit ? this.$route.params.codeInvit : null,
      terms:true,
      termError:false,
      disabled_class : "",
      notice:null,
      msg_error: null,
      role: 'Startup',
      errorMessages: {
        hasMinimumLength: "8 caractères ",
        hasUppercase: "une lettre majuscule, ",
        hasLowercase: "une lettre minuscule, ",
        hasNumber: "un chiffre, ",
        hasSpecialCharacter: "un caractère spécial (comme @, #, $, %, ^, &, *, +, ?, ;, (, , [, ou ]) "
      },
      hasErrors: false,
    };
  },
  mounted() {
    this.$Progress.start();
    var url = window.location.href;
    var lastSlash = url.lastIndexOf('/');
    var codeInvit = url.substring(lastSlash + 1);
    this.$store.dispatch(GET_EMAIL_CODE_INVIT,codeInvit)
    .then(data => {
      if (data.data) {
        this.email = data.data.email;
        this.role = data.data.role ? data.data.role : 'Startup';
      }
      this.$Progress.finish();
    })
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    }),
    passwordRules() {
      return {
        hasMinimumLength: val => val.length >= 8,
        hasUppercase: val => /[A-Z]/.test(val),
        hasLowercase: val => /[a-z]/.test(val),
        hasNumber: val => /[0-9]/.test(val),
        hasSpecialCharacter: val => /[!@#$%^&*\-_+=~?.,:;\'"\\/|()\[\]{}]/.test(val)
      };
    },
    anyErrors() {
      for (let error in this.passwordErrors) {
        if (this.passwordErrors[error]) {
          return true;
        }
      }
      return false;
    },
    passwordErrors() {
      const errors = {};
      this.hasErrors = false; // Reset hasErrors
      for (let rule in this.passwordRules) {
        errors[rule] = !this.passwordRules[rule](this.password);
        if (errors[rule]) {
          this.hasErrors = true; // Set hasErrors to true if any rule fails
        }
      }
      return errors;
    },
  },
  methods: {
    onChange(value){
      this.terms=value;
    },
    onSubmit() {
      this.$store.dispatch(CLEAR_ERROR);
      this.$Progress.start();
      this.disabled_class = "opacity-50 cursor-not-allowed";
      if(!this.terms) {
        this.$Progress.fail();
        this.disabled_class = "";
        return this.termError = true;
      }
      else this.termError = false;
       
      this.$store
        .dispatch(REGISTER, {
          first_name: this.first_name,
          last_name: this.last_name,
          email: this.email,
          password: this.password,
          password_confirmation: this.password_confirmation,
          registration_code: this.registration_code,
          code_invit : this.$route.params.codeInvit,
          role: this.role
        })
        .then(s => {
          this.$Progress.finish();
          this.disabled_class = "";
          if(!this.$route.params.codeInvit){
              this.notice="auth.register_success";
          }else{
              this.notice="auth.verify_user_success";
          }
          })
        .catch(err=>{
          this.msg_error = err.data.meta.messages[0];
          this.notice=null;
          this.$Progress.finish();
          this.disabled_class = "";
        });
    },
    updateRole(role){
      this.role = role
    },
    isArray(value) {
      return Array.isArray(value);
    },
    checkPassword() {
      this.hasMinimumLength = this.password.length >= 8;
      this.hasUppercase = !!this.password.match(/[A-Z]/);
      this.hasLowercase = !!this.password.match(/[a-z]/);
      this.hasNumber = !!this.password.match(/[0-9]/);
      this.hasSpecialCharacter = !!this.password.match(/[!@#$%^&*\-_+=~?.,:;\'"\\/|()\[\]{}]/);
    },
  },
  watch:{
    errors(){
      this.disabled_class = "";
       this.$Progress.fail();
    }
  }
};
</script>
